import * as Sentry from "@sentry/react";
import { logErrorTelemetry } from "@/hooks/useErrorTelemetry";

const SUSTAINED_404_WINDOW_MS = 10 * 60 * 1000;
const SUSTAINED_404_THRESHOLD = 5;

let tasksCreate4xxTotal = 0;
let tasksCreate5xxTotal = 0;
let recent404s: number[] = [];
let last404AlertAt = 0;

const prune404Window = (now: number) => {
  recent404s = recent404s.filter((timestamp) => now - timestamp <= SUSTAINED_404_WINDOW_MS);
};

export function recordTasksCreateHttpStatus(status: number) {
  if (status >= 400 && status < 500) {
    tasksCreate4xxTotal += 1;
  }

  if (status >= 500) {
    tasksCreate5xxTotal += 1;
  }

  if (status !== 404) {
    return;
  }

  const now = Date.now();
  recent404s.push(now);
  prune404Window(now);

  if (recent404s.length < SUSTAINED_404_THRESHOLD || now - last404AlertAt < SUSTAINED_404_WINDOW_MS) {
    return;
  }

  last404AlertAt = now;

  Sentry.captureMessage("Sustained /rest/v1/tasks create 404 rate detected", {
    level: "error",
    tags: {
      endpoint: "/rest/v1/tasks",
      operation: "create",
      status_family: "4xx",
      status_code: "404",
    },
    extra: {
      threshold: SUSTAINED_404_THRESHOLD,
      windowMs: SUSTAINED_404_WINDOW_MS,
      observed404Count: recent404s.length,
    },
  });

  void logErrorTelemetry({
    errorMessage: "Sustained /rest/v1/tasks create 404 rate detected",
    route: typeof window !== "undefined" ? window.location.pathname : "/tasks",
    metadata: {
      endpoint: "/rest/v1/tasks",
      operation: "create",
      status: 404,
      threshold: SUSTAINED_404_THRESHOLD,
      windowMs: SUSTAINED_404_WINDOW_MS,
      observed404Count: recent404s.length,
      tasks_create_http_4xx_total: tasksCreate4xxTotal,
      tasks_create_http_5xx_total: tasksCreate5xxTotal,
    },
  });
}

export function getTasksCreateEndpointCounters() {
  return {
    tasks_create_http_4xx_total: tasksCreate4xxTotal,
    tasks_create_http_5xx_total: tasksCreate5xxTotal,
  };
}
